/**
 * Enumération des clés utilisées pour le stockage local (localStorage) sécurisé.
 *
 * @enum {string}
 */
export enum EKeyOfLocalStorage {
  /** Informations de l'utilisateur connecté */
  USER = 'user',

  /** Token d'authentification (accessToken & refreshToken) */
  TOKEN = 'token',

  /** Paramètres ou configurations de l'application */
  SETTINGS = 'settings',
  isOnboardingImageCommerce = 'onbarding',

  /** Indique si l'utilisateur se trouve sur le dashboard */
  isDashboard = 'dashboard',

  /** Indique si l'utilisateur est dans la section commerce */
  isCommerce = 'commerce',

  /** Indique si l'utilisateur est dans la section Tables */
  isTables = 'tables',

  /** Indique si l'utilisateur est dans la section Horaires du commerce */
  isSchedules = 'schedules',

  /** Indique si l'utilisateur est dans la section Programme du commerce */
  isProgram = 'program',

  /** Indique si l'utilisateur est dans la section Contact du commerce */
  isContact = 'contact',

  /** Indique si l'utilisateur est dans la section Produit */
  isProduct = 'product',

  /** Indique si l'utilisateur est dans la section Promotions */
  isPromotion = 'promotion',

  /** Indique si l'utilisateur est dans la section Catégorie */
  isCategorie = 'categorie',

  /** Indique si l'utilisateur est dans la section Fichiers */
  isFile = 'file',

  /** Indique si l'utilisateur est dans la section Client */
  isClient = 'client',

  /** Indique si l'utilisateur est dans la section Personnel */
  isStaff = 'staff',

  /** Indique si l'utilisateur est dans la section Taxe */
  isTax = 'tax',

  /** Indique si l'utilisateur est dans la section Pays disponible */
  isCountry = 'country',

  /** Indique si l'utilisateur est dans la section Devises */
  isCurrency = 'currency',
  /** Indique si l'utilisateur est dans l'admin side */
  isUser = 'user',
  /** Indique si l'utilisateur est dans l'admin side */
  isPermission = 'permission',
  /** Indique si l'utilisateur est dans l'admin side */
  isRole = 'role',
  isVersion = 'version',

  /** Titre affiché dans la sidebar */
  title = 'title',
  ROLES_ARRAY = 'roles_array',
}
